import { render, staticRenderFns } from "./QueueType.vue?vue&type=template&id=0c29ccf4&lang=pug&"
import script from "./QueueType.vue?vue&type=script&lang=js&"
export * from "./QueueType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports